import { render, staticRenderFns } from "./AddPoints.vue?vue&type=template&id=70e3605e&"
import script from "./AddPoints.vue?vue&type=script&lang=ts&"
export * from "./AddPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports